__webpack_require__.p = "/new-Bidding-Dapp/";